import React from 'react'
import 'vimond-replay/index.css';
import ReactJWPlayer from 'react-jw-player';

class BroadCastVideo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoLoad: false
        }
        this.timer = null;
        this.isHlsLink = true;
    }

    componentDidMount() {
        this.startTimer();
    }

    startTimer = () => {
        let sec = 0;
        this.timer = setInterval(() => {
            if (sec >= 4) {
                this.stop();
            }
            sec++;
        }, 1000);
    }
    stop = () => {
        clearInterval(this.timer);
        this.setState({videoLoad: true});
    }    
    
    // slideBySeconds = (sec) => {
    //     console.log(Math.round(sec.currentTime));
    // }    

    render() {
        

        let streamingUrl = localStorage.programLiveArchiveVideoLink;
        if(streamingUrl){
            if (streamingUrl.search(".m3u8") < 0) {
                this.isHlsLink = false;
            }
        }

        var d = new Date();

        let videoSource = '';
        let videoSourceKey = '';
        
        if(this.isHlsLink){
            
            videoSource = localStorage.programLiveArchiveVideoLink;
            videoSourceKey = d.getTime()*this.props.videoPlayFrom;

        }else{
            
            videoSource = localStorage.programLiveArchiveVideoLink+'#t='+this.props.videoPlayFrom;
            videoSourceKey = d.getTime()*this.props.videoPlayFrom;

        }
        
        return (
            <div className="col-md-12 p0" style={{lineHeight:0}}>
                {localStorage.programLiveArchiveVideoLink !== 'null' && this.state.videoLoad
                ?
                    <>
                        {streamingUrl.search("youtube.com/embed") < 0 ?
                            <ReactJWPlayer
                                autoplay
                                file={videoSource}
                                key={videoSourceKey}
                                playerId='my-id-2231' // bring in the randomly generated playerId
                                playerScript='https://cdn.jwplayer.com/libraries/roy564eO.js'
                                onTime={(event) => {
                                    this.props.slideBySeconds(event);
                                }}
                            />
                        :
                            <iframe style={{width:'100%'}} height="320"
                                title="Broadcast Video"
                                src={videoSource}
                                frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        }
                    </>     
                : 
                ''
                }
                {localStorage.programLiveArchiveVideoLink === 'null' &&
                <div className="p-5 text-danger text-center">Conference Link Not Found</div>
                }
            </div>
        );
    }

}

export default BroadCastVideo;
